module.exports = __webpack_public_path__ + "img/total-express-logo-white.15631f5b.png";